// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"bcddda885f6632155e8a","293":"3ed912011d8141a4cb97","518":"216275e36cfe198b009e","779":"5334086db5a4dfbaada6"}[chunkId] + ".js";
};